/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Heart_viewer = {
    readonly userPortfolios?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "Heart_viewer";
};
export type Heart_viewer$data = Heart_viewer;
export type Heart_viewer$key = {
    readonly " $data"?: Heart_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Heart_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Heart_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]",
      "defaultValue": []
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "loadPortfolioData",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "userPortfolios",
          "name": "portfolios",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Literal",
              "name": "portfolioTypes",
              "value": [
                "HEART"
              ]
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds"
            }
          ],
          "concreteType": "PortfoliosConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfoliosEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioV2",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "serviceId",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '62b6c7bf55d8681c14a6de4122ae3ffb';
export default node;
